import { useEffect, useState } from "react";
import InlineErrors from "./InlineErrors";
import InlineDescription from "./InlineDescription";

const InputText = (props) => {
	const {
		id,
		label,
		name,
		type: { type } = {},
		required = false,
		placeholder,
		pattern,
		description,
		value = "",
		handleChange,
		validateInput,
		notEmptyMessage,
		patternNotMatchMessage,
		modifier,
		inlineErrors,
		showInlineErrors = true,
		maxCharacterLength = 14000,
		isMobileView,
		isHyperionTheme,
		isEmailInput,
		notAllowedDomainMessage,
		allowedEmailDomains,
		children,
		handleClick,
		handleOnKeyDown,
		triggerInputValidation = null,
		ariaControls = null,
		onBlur = null,
	} = props;
	const mainClass = "help-input-text";
	const modifierClass = modifier ? ` ${mainClass}--${modifier}` : "";

	const [hasError, setHasError] = useState();

	useEffect(() => {
		!!inlineErrors?.[name] && setHasError(true);
	}, [inlineErrors, name]);

	const renderLabel = () => {
		return (
			<label
				className={`${mainClass}__label${
					hasError ? ` ${mainClass}__label--error` : ""
				}${value ? ` ${mainClass}__label--filled` : ""}`}
				htmlFor={!hasError ? id : undefined}
			>
				{label && `${label}${required ? "*" : ""}`}
			</label>
		);
	};

	const validateCurrentInput = () => {
		validateInput &&
			validateInput(
				name,
				value,
				required,
				notEmptyMessage,
				pattern,
				patternNotMatchMessage,
				setHasError,
				isEmailInput,
				allowedEmailDomains,
				notAllowedDomainMessage
			);
	};

	useEffect(() => {
		if (triggerInputValidation) validateCurrentInput();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [triggerInputValidation]);

	if (!name) return null;

	return (
		<div className={`${mainClass}${modifierClass}`}>
			{label && !isHyperionTheme && renderLabel()}
			{description?.modalContent && (
				<InlineDescription
					{...description}
					id={id}
					isMobileView={isMobileView}
					position="top"
				/>
			)}
			<input
				className={`${mainClass}__input${
					hasError ? ` ${mainClass}__input--error` : ""
				}`}
				id={id}
				type={type}
				name={name}
				placeholder={label ? null : placeholder}
				required={required}
				aria-required={required}
				aria-describedby={
					[
						hasError ? `${id}_error` : null,
						(description?.modalContent || description?.text) ? `${id}-message-instructions` : null,
					]
						.filter(Boolean)
						.join(' ') || undefined
				}
				value={value}
				onChange={handleChange}
				maxLength={maxCharacterLength}
				onClick={() => handleClick && handleClick()}
				onKeyDown={(event) => handleOnKeyDown && handleOnKeyDown(event)}
				onBlur={(event) => {
					if (!onBlur || onBlur(event)) {
						validateCurrentInput(event);
					}
				}}
				aria-controls={ariaControls}
			/>
			{!!children && children}
			{label && isHyperionTheme && renderLabel()}
			{inlineErrors && showInlineErrors && (
				<InlineErrors validate={id} errorMessages={inlineErrors} />
			)}
			{description?.text && (
				<InlineDescription
					{...description}
					id={id}
					isMobileView={isMobileView}
					position="bottom"
				/>
			)}
		</div>
	);
};

export default InputText;
